var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBambooHr = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8656 19.6114C33.068 19.6114 36.6969 23.2101 36.6969 27.3972C36.6969 31.9064 33.2176 35.415 28.6223 35.415C24.4508 35.415 20.8156 32.4976 20.8156 27.8155V12.6H23.2312L23.2321 21.8972L23.5185 21.5988C24.57 20.5635 26.069 19.6114 28.8656 19.6114ZM28.6223 33.2307C32.0494 33.2307 34.2267 30.8108 34.2267 27.6194C34.2267 24.6857 32.169 21.885 28.6769 21.885C25.1853 21.885 23.02 24.4974 23.02 27.6781C23.02 30.8573 25.5881 33.2307 28.6223 33.2307ZM15.9716 14.4369C17.7744 16.3255 17.9639 17.3807 18.6038 19.2139L19.6762 22.6989C19.6762 22.6989 18.6186 22.5019 17.7522 22.3723C16.7472 22.221 16.3025 22.073 15.025 21.5564C13.7467 21.0398 12.5909 19.7762 11.4577 18.3671C10.3249 16.9571 7.67993 14.7419 7.67993 14.7419C7.67993 14.7419 8.49788 14.7957 9.32692 15.0004C10.0064 15.1688 11.7754 15.738 13.6004 16.6786C14.0052 16.8866 14.2297 17.0215 14.6288 17.267C15.2355 17.6388 15.8738 18.1934 16.4846 18.8082C17.2026 19.5303 17.8315 20.111 18.3683 20.7572C17.7838 19.6898 16.2688 15.8464 13.3069 12.6742C13.0167 12.3635 15.3542 13.7894 15.9716 14.4369Z",
    fill: "#73C41D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBambooHr, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BambooHR.b43a29f5.svg";
export { ForwardRef as ReactComponent };